import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getPatronByUserQuery } from '../../components/artifacts/util/patronIdUtils'
import useNotifications from '../useNotifications'

/**
 * A hook to use a Patron info object. Accepts a patronId and boolean which tells us if
 * we should attempt to retrieve the patron info or not parameter.
 * @param {string} patronId uploader id retrieved from artifact as artifact.uploaderId
 * @returns {Object} object with loading boolean, error status/data, and patron object
 */
const usePatron = (userQuery, userQueryIsPatronId) => {
  const { t } = useTranslation()
  const [patron, setPatron] = useState(null)
  const { error } = useNotifications()
  useEffect(() => {
    if (userQuery) {
      getPatronByUserQuery(userQuery, userQueryIsPatronId)
        .then((response) => {
          setPatron(response.data)
        })
        .catch((err) => {
          error(
            t('artifacts.error.gettingPatronData', {
              defaultValue: `Error getting patron data: ${err.message || ''}`,
              message: err.message || '',
            }),
            err
          )
        })
    } else {
      setPatron(null)
    }
  }, [error, userQuery, userQueryIsPatronId, t])

  return {
    patron,
  }
}

export default usePatron
